export interface TrendyolOrderProduct {
  barcode: string;
  productName: string;
  quantity: number;
}

export const trendyolOrderProductFromResponse = (
  responseData: any,
): TrendyolOrderProduct => ({
  barcode: responseData.barcode,
  productName: responseData.product_name,
  quantity: responseData.quantity,
});
